import { render, staticRenderFns } from "./ApprovalActDlg.vue?vue&type=template&id=239c67d0&"
import script from "./ApprovalActDlg.vue?vue&type=script&lang=js&"
export * from "./ApprovalActDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports